import React, { useContext, useState, useEffect } from 'react';
import { ProjectContext } from '../../contexts/projectContext';
import { CurrentUserContext } from '../../contexts/currentUserContext';
import { PrettyContent } from '../Content';
import Video from './Video';
import CreativeCard from './RecommendedCreativeCard';
import { useQuery } from '@apollo/client';
import { GET_RECOMMENDED_USERS_FOR_PROJECT } from '../../graphql/queries/recommendedUsers';
import { GET_USERS_BY_IDS } from '../../graphql/GET_USERS_BY_IDS';
import { MessageContextProvider } from '../../contexts/messageContext';
import RoomListsContextProvider from '../../contexts/roomListsContext';
interface IUser {
  id: number;
  name: string;
  avatar: string;
  location: string;
  bio: string;
  professions?: string[];
  collaborationRoles?: string[];
  status?: string;
  similarityScore?: number;
}

const Story = () => {
    const project = useContext(ProjectContext);
    const currentUser = useContext(CurrentUserContext);
    const isProjectOwner = project?.author?.id?.toString() === currentUser?.id?.toString();
    const [recommendedUsers, setRecommendedUsers] = useState<IUser[]>([]);
    const [, setMatchUser] = useState<IUser | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    // Fetch recommended user IDs
    const { data: recommendationData, error: recommendationError } = useQuery(GET_RECOMMENDED_USERS_FOR_PROJECT, {
      variables: {
        projectId: Number(project.id),
        topN: 5
      },
      skip: !project.id
    });

    const { data: userData, error: userDataError } = useQuery(GET_USERS_BY_IDS, {
      variables: {
        ids: recommendationData?.getRecommendedUsersForProject?.userIds || []
      },
      skip: !recommendationData?.getRecommendedUsersForProject?.userIds?.length
    });

    useEffect(() => {
      if (userData?.getUsersByIds && userData.getUsersByIds.length > 0) {
        console.log('Received user data:', userData);
        const processedUsers = userData.getUsersByIds.map((user: any) => ({
          id: user.id,
          name: user.profile?.name || 'Unknown Name',
          avatar: user.avatar?.fileUrl || '',
          bio: user.profile?.bio || 'No bio available',
          location: user.profile?.location || 'Location not specified',
          professions: user.professions?.map((p: any) => p.name) || [],
          collaborationRoles: user.skills?.map((s: any) => s.name) || [],
          status: user.profile?.collaborationStatus,
          similarityScore: 0.5
        }));
        setRecommendedUsers(processedUsers.slice(0, 3));
        if (processedUsers.length >= 4) {
          setMatchUser(processedUsers[3]);
        }
        setLoading(false);
      }
    }, [userData]);

    return (
          <div>
            <div className="page-project-details p-t-1 p-b-2">
              <h3 className="is-size-5 font-size-20 p-t-3 p-b-3 has-text-weight-medium">Project Summary</h3>
              <PrettyContent
                content={project.description}
                isLineBreakEnabled={true}
              />
            </div>
            <Video project={project} />
            {isProjectOwner && (
              <div className="invite-creatives-section m-t-5">
                <div className="invite-creatives-header">
                  <h3 className="is-size-5 has-text-weight-medium">Recommended Creatives to Collaborate</h3>
                  {loading && <p>Finding the best matches for your project...</p>}
                  {recommendationError && <p>Error loading recommendations: {recommendationError.message}</p>}
                  {userDataError && <p>Error loading user data: {userDataError.message}</p>}
                </div>
                <div className="invite-creatives-list">
                  <div className="columns is-multiline is-mobile">
                    <RoomListsContextProvider>
                      <MessageContextProvider currentUser={currentUser}>
                        {recommendedUsers.length > 0 ? (
                          recommendedUsers.map((user, index) => (
                            <CreativeCard
                              key={user.id ?? index}
                              name={user.name ?? 'Unknown Name'}
                              avatar={user.avatar ?? ''}
                              location={user.location ?? 'Location not specified'}
                              bio={user.bio ?? 'No bio available'}
                              professions={user.professions ?? []}
                              collaborationRoles={user.collaborationRoles ?? []}
                              status={user.status ?? 'Unvailable'}
                              similarityScore={0.5}
                              isProjectOwner={isProjectOwner}
                              user={user}
                              currentUser={currentUser}
                            />
                          ))
                        ) : !loading ? (
                          <div className="column is-12">
                            <p>No recommended users found for this project.</p>
                            {recommendationData && (
                              <p>Received {recommendationData.getRecommendedUsersForProject?.userIds?.length ?? 0} recommendations.</p>
                            )}
                          </div>
                        ) : null}
                      </MessageContextProvider>
                    </RoomListsContextProvider>
                  </div>
                </div>
            </div>
          )}
         </div>
    );
};

export default Story;